import {
  Typography,
  Dialog as MUIDialog,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
} from "@mui/material";
import { CloseOutlined } from "@mui/icons-material";
import { colors } from "../../css components/Style";

export default function ViewAgreement({ viewAgreement, setViewAgreement }) {
  const handleClose = () => {
    setViewAgreement({
      data: viewAgreement?.data,
      state: false,
    });
  };

  const agreementLink = viewAgreement?.data?.is_verified
    ? viewAgreement?.data?.signed_agreement_link
    : viewAgreement?.data?.unsigned_agreement_link;

  return (
    <MUIDialog
      open={viewAgreement?.state}
      onClose={handleClose}
      maxWidth="xl"
      fullWidth
      PaperProps={{
        sx: {
          minWidth: "95%",
          height: "100%",
        },
      }}
    >
      <DialogTitle sx={{ px: 4, py: 3 }}>
        <Grid container alignItems="center" justifyContent="space-between">
          <Grid item>
            <Typography variant="h4" color={colors.purple}>
              View Agreement
            </Typography>
          </Grid>
          <Grid item>
            <IconButton onClick={handleClose}>
              <CloseOutlined />
            </IconButton>
          </Grid>
        </Grid>
      </DialogTitle>

      <DialogContent sx={{ px: 4, pb: 4 }}>
        <iframe
          title="View Agreement"
          src={`${agreementLink}#zoom=100`}
          style={{ width: "100%", height: "550px", border: "none" }}
        />
      </DialogContent>
    </MUIDialog>
  );
}
